import React from "react";
import PermissionPill from "../../../global/ui/PermissionPill";
import ExpiryDatePicker from "../../../global/ui/ExpiryDatePicker";
import { createFullName } from "../../../utils";
import moment from "moment";
import { ACCESS_LEVEL_OPTIONS, LOCATION_INFO_OPTIONS } from "../../../data/data";
import NoData from "../../../global/ui/NoData";

const UsersTable = ({ users, onChangeField, onEdit }: any) => {
    if (users?.length === 0) {
        return <NoData />;
    }
    return (
        <div className="ua-table-wrap">
            <table className="ua-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Department</th>
                        <th>Role</th>
                        <th>Access Level</th>
                        <th>Location Info Access</th>
                        <th>Expiry Date</th>
                        <th className="ua-table__edit-col" />
                    </tr>
                </thead>
                <tbody>
                    {users.map((item: any) => {
                        const user = item?.user
                        return (
                            <tr key={item?.id}>
                                <td>
                                    <div className="ua-user">
                                        <img src={user?.profile_image || '../../../../assets/images/yello-logo.png'} alt={user?.first_name} className="ua-user__avatar" />
                                        <span className="ua-user__name">{createFullName(user?.first_name, user?.last_name)}</span>
                                    </div>
                                </td>
                                <td className="ua-cell-muted">{user?.email || 'N/A'}</td>
                                <td className="ua-cell-muted">{user?.mobile_number || 'N/A'}</td>
                                <td className="ua-cell-muted">{item?.department || 'Locations'}</td>
                                <td className="ua-cell-muted">{item?.role || 'N/A'}</td>
                                <td>
                                    <PermissionPill
                                        value={item?.access_level}
                                        options={ACCESS_LEVEL_OPTIONS}
                                        onChange={(v: any) => onChangeField(item, 'accessLevel', v)}
                                    />
                                </td>
                                <td>
                                    <PermissionPill
                                        value={item.can_view_location ? 'Yes' : 'No'}
                                        options={LOCATION_INFO_OPTIONS}
                                        onChange={(v: any) => onChangeField(item, 'locationAccess', v)}
                                    />
                                </td>
                                <td>
                                    <ExpiryDatePicker
                                        value={item?.expiry_date ? moment(item?.expiry_date, 'YYYY-MM-DD').format('DD/MM/YY') : 'Never'}
                                        onChange={(v: any) => onChangeField(item, 'expiryDate', v)}
                                    />
                                </td>
                                <td>
                                    <button className="ua-edit-btn" onClick={() => onEdit(item)} aria-label="Edit user">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                            <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
};

export default UsersTable